export default __webpack_public_path__ + "static/media/whitepaper.74d8ffa6.pdf";